import NotificationPopUp from 'components/NotificationPopup';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Col, Row } from 'reactstrap';
// import { getPageTitle } from 'utils/getPageTitle';

interface headerProps {
  totalCount?: any;
  heading?: string;
}

const Header: React.FC<headerProps> = ({ totalCount,heading }) => {
  const [showNotification, setShowNotification] = useState(false);

  const navigate = useNavigate();
  // const {pathname} = useLocation()

  // const heading = getPageTitle(pathname);


  const handleIconClick = () => {
    navigate(-1);
  };
  return (
    <>
      <Row className="header">
        <Col md="7" sm="6">
          <h4>
            <i
              className='bi bi-arrow-left'
              style={{ cursor: 'pointer' }}
              onClick={handleIconClick}
            ></i>
            <span className="heading-text">{heading}</span>
            {totalCount ? (
              <span className="total-count">{`(${totalCount})`}</span>
            ) : null}
          </h4>
        </Col>
        <Col className="header-navigation-item text-end">
          <div onClick={() => setShowNotification((prev) => !prev)}>
            <i className="bi bi-bell"></i>
            <i className="bi bi-dot dot-icon"></i>
          </div>
          {showNotification && (
           <NotificationPopUp
              onClose={() => setShowNotification(false)}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default Header;
